export default "__VITE_ASSET__DJThUhTr__"